import styled from "@emotion/styled";
import { IconButton } from "@mui/material";
import Box from "@mui/material/Box";

export const StyledHeader = styled(Box)<{ shouldCenter: boolean }>`
  display: flex;
  align-items: center;
  justify-content: ${({ shouldCenter }) =>
    shouldCenter ? "center" : "space-between"};
  margin: 1.25rem 1.25rem 2rem 1.25rem;
`;

export const StyledIconContainer = styled(Box, {
  shouldForwardProp: (props) => props !== "bgColor",
})<{ bgColor?: string }>`
  margin-right: 1rem;
  width: 48px;
  height: 48px;
  background-color: ${({ bgColor }) => bgColor || "#F6F8FA"};
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.75rem;
`;

export const StyledTitleContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

export const StyledButton = styled(IconButton)`
  border-radius: 8px;
  background-color: rgba(255, 255, 255, 0.15);
`;
